import React, { useState, useEffect, lazy, Suspense } from 'react';
import SharedHelmet from ".././Helmet";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const BlinkingText = lazy(() => import('../../BlinkingText'));
const RelatedLinks = lazy(() => import('../RelatedLinks'));
const MainCalculatorsList = lazy(() => import('./MainCalculators'));
const TITLE = "كم باقي على الأولمبياد 2028 - العد التنازلي للأولمبياد";
const DESCRIPTION = "كم باقي على الأولمبياد 2028؟ العد التنازلي للأولمبياد يتيح لك معرفة الوقت المتبقي حتى بداية الحدث الرياضي الأكثر أهمية في العالم. تابع العد التنازلي وكن على اطلاع حول الموعد المحدد لانطلاق الأولمبياد.";
const KEYWORDS = "الأولمبياد 2028, كم باقي على الأولمبياد, العد التنازلي للأولمبياد, متى الأولمبياد, الألعاب الأولمبية, العد التنازلي للألعاب الأولمبية, موعد الأولمبياد, المنافسات الأولمبية";
const OG_URL = "https://do-calculate.com/articles-ar/olympics";
function OlympicsCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const olympicsDate = new Date("2028-07-26T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(olympicsDate));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(olympicsDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    return (
        <div className="rtl">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>كم باقي على الأولمبياد 2028</h1>
            <Suspense fallback={<div>Loading...</div>}>
                <BlinkingText text="كم باقي على الأولمبياد: من المتوقع أن تبدأ البطولة يوم الخميس 26 يوليو 2028 في لوس أنجلوس، الولايات المتحدة." />
            </Suspense>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px', textAlign: 'center' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                        <thead>
                            <tr>
                                <th>يوم</th>
                                <th>ساعة</th>
                                <th>دقيقة</th>
                                <th>ثوانٍ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days}</td>
                                <td>{timeLeft.hours}</td>
                                <td>{timeLeft.minutes}</td>
                                <td>{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>معلومات عن الأولمبياد 2028</h3>
                    <p>
                        الألعاب الأولمبية هي حدث رياضي عالمي يقام كل أربع سنوات، حيث يتنافس الرياضيون من جميع أنحاء العالم في مختلف الرياضات. الأولمبياد 2028 سيُقام في لوس أنجلوس، الولايات المتحدة، ويُنتظر أن يشهد منافسات مثيرة في العديد من الرياضات. يترقب العالم هذا الحدث بكل شغف.
                    </p>
                    <p>
                        ستكون هذه النسخة من الأولمبياد مميزة حيث ستعود الألعاب إلى الولايات المتحدة بعد مضي 32 عامًا على آخر استضافة لها في 1996 في أتلانتا.
                    </p>
                    <hr />
                    <Suspense fallback={<div>Loading...</div>}>
                        <RelatedLinks />
                    </Suspense>
                </div>
                <div className="col">
                    <Suspense fallback={<div>Loading...</div>}>
                        <MainCalculatorsList />
                    </Suspense>
                </div>
            </div>
        </div>
    );
}
export default OlympicsCountdown;
